"use client";

import { Image as ImageType } from "@/types/Image";
import Image from "next/image";
import { useState } from "react";
import AlbumModal from "../AlbumModal";
import AlbumCarousel from "../AlbumModal/AlbumCarousel";
import "./index.scss";

const HeroImagesGrid = ({ images }: { images: ImageType[] }) => {
  const [isAlbumModalOpened, setIsAlbumModalOpened] = useState(false);
  const [selectedImageIndex, setSelectedImageIndex] = useState(0);

  const openAlbumModal = (imageIndex: number) => {
    setSelectedImageIndex(imageIndex);
    setIsAlbumModalOpened(true);
  };

  let numberOfAdditionalImages = 4;
  if (images.length === 0 || images.length === 1) {
    numberOfAdditionalImages = 0;
  } else if (images.length === 2) {
    numberOfAdditionalImages = 1;
  } else if (images.length === 3) {
    numberOfAdditionalImages = 2;
  } else if (images.length === 4) {
    numberOfAdditionalImages = 2;
  }
  const additionalImageNodes =
    numberOfAdditionalImages === 0
      ? []
      : images
          .slice(1, numberOfAdditionalImages + 1)
          .map((image, imageIndex) => {
            return (
              <div
                className="additional-image"
                key={`${image.src}-${image.alt}`}
              >
                <Image
                  src={image.src}
                  alt={image.alt}
                  fill
                  sizes="(max-width: 768px) 100vw, 25vw"
                  quality={100}
                  priority={true}
                  onClick={() => {
                    openAlbumModal(imageIndex + 1);
                  }}
                />
              </div>
            );
          });

  const firstImage = images[0];
  return (
    <div
      className={`component hero-images-grid number-of-additional-images-${numberOfAdditionalImages}`}
    >
      <div className="hero-images-grid-inner-wrapper">
        <div className="hero-images-grid-inner-wrapper-2">
          <div className="desktop-view">
            <div className="main-image">
              {firstImage && (
                <Image
                  src={firstImage.src}
                  alt={firstImage.alt}
                  fill
                  sizes="(max-width: 768px) 100vw, 50vw"
                  quality={100}
                  priority={true}
                  onClick={() => {
                    openAlbumModal(0);
                  }}
                />
              )}
            </div>
            {additionalImageNodes.length > 0 && (
              <div className="additional-images">{additionalImageNodes}</div>
            )}
            <button
              className="view-all-photos"
              onClick={() => {
                openAlbumModal(0);
              }}
            >
              View all photos
            </button>
          </div>

          <div className="mobile-view">
            <AlbumCarousel
              images={images}
              sizes="100vw"
              onClick={openAlbumModal}
              objectFit="cover"
            />
          </div>
        </div>
      </div>

      {isAlbumModalOpened && (
        <AlbumModal
          images={images}
          initialImageIndex={selectedImageIndex}
          onClose={() => {
            setIsAlbumModalOpened(false);
          }}
        />
      )}
    </div>
  );
};

export default HeroImagesGrid;
